<template>
  <link-manage></link-manage>
</template>

<script>
import LinkManage from "@/views/components/link-manage";
export default {
  name: "contact-manage",
  components: { LinkManage },
};
</script>
